import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsApiLazy = loadable(() => import(/* webpackChunkName: "SettingsLight" */ './SettingsApiSuspense'));

export const SettingsApiAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsApiLazy />
    </DelayedSuspense>
);
